import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=ccae298a&scoped=true&"
import script from "./step2.vue?vue&type=script&lang=ts&"
export * from "./step2.vue?vue&type=script&lang=ts&"
import style0 from "./step2.vue?vue&type=style&index=0&id=ccae298a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccae298a",
  null
  
)

export default component.exports